<template>
	<lcsj-dialog v-model="showDialog" ref="editForm" title="采购入库单详情" width="80%" @close="closeDialog" cancel-text="关闭"
		:confirm-text="canAudit ? '审核入库' : ''" :confirm-loading="isSubmitting" @confirm="auditInputStore">
		<div v-loading="loading" class="main_bg" element-loading-text="加载中...">
			<div class="item_info border_Warningcolor">
				<el-descriptions class="margin-top" title="基本信息" :column="3" border>
					<el-descriptions-item label="入库单号">{{ editForm.inputStoreNo }}</el-descriptions-item>
					<el-descriptions-item label="入库人">{{ editForm.inputUserName }}</el-descriptions-item>
					<el-descriptions-item label="入库时间">{{ editForm.inputDate }}</el-descriptions-item>
					<el-descriptions-item span="3" label="备注">{{ editForm.remark }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">商品信息</div>
				</div>
				<div class="tableData">
					<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData">
						<template #price>
							<el-table-column v-if="canSeeCost" label="单价" min-width="100" align="center">
								<template #default="scope">
									<span style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.price || 0">￥{{ Number(scope.row.price || 0).toFixed(2) }} 元</span>
								</template>
							</el-table-column>
						</template>
						<template #money>
							<el-table-column v-if="canSeeCost" label="金额" min-width="100" align="center">
								<template #default="scope">
									<span style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.money || 0">￥{{ Number(scope.row.money || 0).toFixed(2) }} 元</span>
								</template>
							</el-table-column>
						</template>
					</STable>
				</div>
			</div>
		</div>
		
	</lcsj-dialog>
</template>
<script>
import costPermission from "@/utils/costPermission.js";
import { GetInputStoreDeatail, AuditInputStore } from "@/api/receiptApi.js";
export default {
	mixins: [costPermission],
	props: [],
	data() {
		return {
			showDialog: false,
			detailLoaded: false,
			isSubmitting: false,
			editForm: {
				keyId: "",
				inputStoreNo: "",
				inputUserName: "",
				inputUserKeyId: "",
				inputDate: "",
				remark: ""
			},
			goodsInfoData: [],
			loading: false, // 显示加载
			listData: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true,
					type: "index"
				},
				{
					prop: "supplyName",
					label: "供应商",
					align: "center",
					wdth: "60"
				},
				{
					prop: "goodsInfo.type",
					label: "商品品牌",
					align: "center",
					isKeep: true,
					wdth: "100"
				},
				{
					prop: "goodsInfo.name",
					label: "商品名称",
					align: "center",
					minWidth: "220"
				},
				{
					prop: "goodsInfo.qiuJing",
					label: "球镜",
					wdth: "60",
					align: "center"
				},
				{
					prop: "goodsInfo.zhuJing",
					label: "柱镜",
					align: "center",
					wdth: "60"
				},
				{
					slot: "price",
					label: "单价",
					align: "center",
					wdth: "60"
				},
				{
					prop: "quantity",
					label: "数量",
					align: "center",
					wdth: "60"
				},
				{
					slot: "money",
					label: "金额",
					align: "center",
					wdth: "60"
				}
			],

			// 按钮权限
			btnPermission: {
				audit: false
			}
		};
	},
	computed: {
		canAudit() {
			return this.detailLoaded && !this.loading && this.btnPermission.audit && !!this.editForm.keyId && !this.editForm.inputUserKeyId;
		}
	},
	watch: {},
	components: {},
	created() {
		// 按钮权限
		this.getBtnPermission();
	},
	methods: {
		// 显示
		showDetailDialog(keyId) {
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			this.editForm.keyId = keyId;
			this.showDialog = true;
			// 初始列
			this.getCheckBox(this.listColumns.map((item) => item.label));
			this.getListData();
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取入库单详情
		getListData() {
			this.loading = true;
			const params = {
				keyId: this.editForm.keyId
			};
			GetInputStoreDeatail(params)
				.then((res) => {
					if (res.code == 1) {
						this.editForm.inputStoreNo = res.data.inputStoreNo;
						this.editForm.remark = res.data.remark;
						this.editForm.inputUserName = res.data.inputUserName;
						this.editForm.inputUserKeyId = res.data.inputUserKeyId;
						this.detailLoaded = true;
						this.editForm.inputDate = res.data.inputDate;
						this.goodsInfoData = res.data.dtls;

						this.loading = false;
						this.listData = res.data.dtls;
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("生成失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.detailLoaded = false;
			this.editForm = {
				keyId: "",
				inputStoreNo: "",
				inputUserName: "",
				inputUserKeyId: "",
				inputDate: "",
				remark: ""
			};
			this.goodsInfoData = [];
			this.listData = [];
		},
		// 关闭
		closeDialog() {
			this.$data.editForm = this.$options.data.call(this).editForm;
			this.loading = false;
			this.showDialog = false;
		},
		//判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		},
		// 审核
		async auditInputStore() {
			if (!this.canAudit || this.isSubmitting) return;
			const { keyId, inputStoreNo } = this.editForm;
			this.isSubmitting = true;
			try {
				try {
					await this.$confirm("确定要审核入库单【" + inputStoreNo + "】吗?", "信息", {
						confirmButtonText: "确定", cancelButtonText: "取消", type: "warning"
					});
				} catch (_) {
					return;
				}
				if (!this.showDialog || this.editForm.keyId !== keyId || !this.canAudit) return;
				const res = await AuditInputStore({ keyIds: [keyId] });
				if (res.code === 1) {
					this.$message({ type: "success", message: "已成功审核入库单【" + inputStoreNo + "】!" });
					this.detailLoaded = false;
					this.showDialog = false;
					this.$parent.getListData();
				} else {
					this.$message({ type: "info", message: res.msg });
				}
			} catch (_) {
				this.$message.error("审核失败，请稍后再试！");
			} finally {
				this.isSubmitting = false;
			}
		},
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.audit = this.$checkBtnPermission("/inputStore/index", "audit");
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.goodsInfoData {
		font-size: 18px;
		font-weight: 900;
		font-family: "楷体";
	}
}
</style>
